import { Pipe, PipeTransform } from '@angular/core';
import * as vkbeautify from 'vkbeautify';

@Pipe({
   name: 'xmlbeauty'
})

export class XmlbeautyPipe implements PipeTransform {
   transform(value: string): string {
      return vkbeautify.xml(value, 2);
   }
}
